import { module } from 'modujs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.scroll = this.modules.Scroll.main.lenis;
        this.speed = this.el.dataset.speed ? parseInt( this.el.dataset.speed ) : 10;
        this.scroll.on( 'scroll', args => {
            this.el.style.transform = 'rotate(' + ( this.scroll.animatedScroll / this.speed ) + 'deg)';
        });
    }

}
